import * as types from "./areatype";

export const area = {
  namespaced: true,

  state: {
    pos: {
      x: 0,
      y: 0
    },
    crop: {
      width: 210,
      height: 210
    }
  },
  getters: {
  },
  mutations: {
    setPos(state, pos) {
      state.pos.x = Math.floor(pos.x);
      state.pos.y = Math.floor(pos.y);
      if (state.pos.x < 0)
        state.pos.x = 0;
      if (state.pos.y < 0)
        state.pos.y = 0;

    }
  },
  actions: {
    [types.SET_POS]({ commit }, pos) {
      commit("setPos", pos);
    }
  }
};
